import { GeographicInfoCountry } from "@/Common/Models/Localization/GeographicInfoCountry";
import { MedfarDictionariesValidationHelper } from "@/ContactDirectory/Helpers/MedfarDictionariesValidationHelper";
import { DirectoryPharmacy } from "@/ContactDirectory/Models//DirectoryPharmacy";
import { BaseContactDirectoryValidator } from "./BaseContactDirectoryValidator";
import { IDirectoryAddressValidationResult } from "./DirectoryAddressValidator";

export interface IDirectoryPharmacyValidationResult {
    banner: boolean;
    pharmacists: boolean;
    faxNumber: boolean;
    phoneNumber: boolean;
    address: IDirectoryAddressValidationResult;
    isFormValid: boolean;
    areNumbersDuplicate: boolean;
}

export class DirectoryPharmacyValidator extends BaseContactDirectoryValidator {
    public constructor(validationHelper: MedfarDictionariesValidationHelper, countries: GeographicInfoCountry[]) {
        super(validationHelper, countries);
    }

    public validate(model: DirectoryPharmacy): IDirectoryPharmacyValidationResult {
        const faxNumber = model.faxNumbers?.firstOrDefault();
        const phoneNumber = model.phoneNumbers?.firstOrDefault();

        const isBannerValid = !IsNullOrWhiteSpace(model.banner);
        const isPharmacistsValid = !IsNullOrWhiteSpace(model.pharmacists);
        const addressValidResult = this.addressValidator.validate(model.address, true);
        const isFaxNumberValid = this.isNumberValid(faxNumber);
        const isPhoneNumberValid = this.isNumberValid(phoneNumber);
        const areNumbersDuplicate =
            isFaxNumberValid
            && isPhoneNumberValid
            && this.countries[faxNumber.countryId].PhoneCode === this.countries[phoneNumber.countryId].PhoneCode
            && faxNumber.number === phoneNumber.number;

        const isFormValid = isBannerValid
            && isPharmacistsValid
            && addressValidResult.isFormValid
            && model.faxNumbers.length == 1
            && model.phoneNumbers.length == 1
            && isFaxNumberValid
            && isPhoneNumberValid;

        return {
            banner: isBannerValid,
            pharmacists: isPharmacistsValid,
            address: addressValidResult,
            faxNumber: isFaxNumberValid,
            phoneNumber: isPhoneNumberValid,
            isFormValid: isFormValid,
            areNumbersDuplicate
        };
    }
}
